export default "__VITE_PUBLIC_ASSET__b429f792__"